export const POS_READ = "pos.read";
/** Every write in the catalogue: outlets, categories, items, variants, prices, modifier groups, photos, archive and restore. */
export const POS_CATALOGUE = "pos.catalogue";
